module.exports = __webpack_public_path__ + "static/solar-screen-patio-shades-1a864a9c1de35e77222f7bec54457650.png";